import React, { useEffect } from 'react';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import CreditItem from './credit-item';
import CreditForm from './credit-form';
import { updateControl } from '../../../../../domain/validation/validation';

const ReferCredit = () => {

    const dispatch = useAppDispatch();
    const cartData = useAppSelector(store => store.root.cartData);
    const referCreditControl = useAppSelector(store => store.root.referCreditControl);

    /**
     * Every time cartData changes (after each relevant ajax request) ---> credit textbox value should be updated.
     */
    useEffect(() => {
        dispatch(
            rootActions.setControl({
                controlName: 'referCreditControl',
                control: updateControl(
                    referCreditControl,
                    cartData?.priceData?.referCredit?.toString() || '',
                    false,
                )
            })
        );
    },
        // referCreditControl change is irrelevant here
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [cartData, dispatch]);

    return (
        <>
            {
                cartData.isReferFriendEnabled && cartData.priceData.referCredit > 0 &&
                <div>
                    { cartData.priceData.selectedUserCredit > 0 && <CreditItem /> }
                    { cartData.priceData.selectedUserCredit <= 0 && <CreditForm /> }
                </div>
            }
        </>
    )
};

export default ReferCredit;